import { Box, Text, Heading, VStack } from '@chakra-ui/react';

export function NoAccess() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh" padding={8}>
      <VStack spacing={4} textAlign="center">
        <Heading size="lg" color="gray.700">
          No Access
        </Heading>
        <Text fontSize="md" color="gray.600" maxWidth="500px">
          You don't have permission to access this section of Creative Hub.
        </Text>
        <Text fontSize="sm" color="gray.500">
          Please contact your administrator if you believe this is an error.
        </Text>
      </VStack>
    </Box>
  );
}
